const doc = [({"en":({"js":({"admin":({"highscore_generation_teams":({"table":({"user_id":"User ID", "schools_uni_c_id":"Schools UNI-C ID"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;